import axios from 'axiosConfig';
import {
  sewan_search, url_sewan_change_organization, url_sewan_create_organisation, url_sewan_create_site, url_sewan_create_user, url_sewan_get_identites,
  url_sewan_get_parent_site, url_sewan_get_relations
} from "./vars";

//A FAIRE : REDEFINIR UN ENTRYPOINT SPECIALEMENT POUR CA !!!!//
// searchId = contient la recherche physique
// types_client = client|site|utilisateur|multi-site|
// services = mobile
export const searchSewan = (searchId, types_client, services) => {
  return axios.post(sewan_search, {
    searchId: searchId,
    types_client: types_client ? types_client : [],
    services: services ? services : []
  })
}


export const useSewanGetRelations = (entity, services, subsitute_sims) =>{
  return axios.post(url_sewan_get_relations, {
    ownerId: entity,
    services: services,

  })
}
//
//   if (!shouldChunkPhoneSearch) {
//     return axios.post(url_sewan_get_relations, basePayload)
//   }
//
//   const mergedData = {}
//   let mergedTargetSummary = null
//   const chunks = chunkArray(phoneNumbers, 40)
//
//   for (const chunk of chunks) {
//     const response = await axios.post(url_sewan_get_relations, {
//       ...basePayload,
//       target_filters: {
//         ...basePayload.target_filters,
//         phone_numbers: chunk,
//       },
//     })
//     mergeRelationPayload(mergedData, response?.data?.data || {})
//     mergedTargetSummary = mergeTargetSummary(
//       mergedTargetSummary || {},
//       response?.data?.target_summary
//     )
//   }
//
//   return {data: {data: mergedData, target_summary: mergedTargetSummary}}
// }

export const functionalitySewanGetParentSite = (parent_id, type) =>{
  return  axios.post(url_sewan_get_parent_site, {
    per_id : parent_id,
    per_type: type
  })
}

export const functionalitySewanGetIdentites = (siteListIDs) =>{
  return  axios.post(url_sewan_get_identites, {
    list_ID : siteListIDs,
  })
}

export const changeOrganization = (entity) =>{
  return axios.post(url_sewan_change_organization, {
    organization_id: entity,
  })
}

export const createOrganisation = ( entity ) =>{
  return axios.post(url_sewan_create_organisation, {
    data : entity
  })
}

export const createSite = ( entity, organisationID ) =>{
  return axios.post(url_sewan_create_site, {
    data : entity,
    organisation_id: organisationID
  })
}

export const createUser = ( entity, organisationID ) =>{
  return axios.post(url_sewan_create_user, {
    data : entity,
    organisationID : organisationID,
  })
}

